// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:21:31

export default {
  "id": "vibrant-hearts-glamour-vs-punk",
  "slug": "vibrant-hearts-glamour-vs-punk",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/16d59825abb44f3a8bb8a3a5ef77ecbe-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/16d59825abb44f3a8bb8a3a5ef77ecbe/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Vibrant Hearts Glamour vs Punk",
      "description": "Two best girlfriends, Lily and Roxana, are striking opposites. Lily is the personification of tenderness and romance, dressed in airy pink dresses decorated with sequins and floral patterns. Roxanne is the true queen of punk rock, with her black leather dresses, gothic earrings and bold hairstyles. But do not forget about the third girlfriend, Melody, who masterfully combines both styles. Players will be able to experiment with outfits and choose which one is best suited for Valentine's Day!",
      "instructions": "Meet three BFF, who are getting ready to celebrate the long-awaited holiday. Each of the girlfriends has her own special fashion preferences, but it only depends on you in which outfits they will celebrate the holiday. The most successful images can be saved at the end of the game as PNG images. Depending on the gaming device, a computer mouse click or a simple touch on touchscreens is used to control it.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "fashion",
        "girls",
        "hairstyle",
        "makeup",
        "valentine"
      ]
    },
    "zh-CN": {
      "title": "活力之心：华丽对朋克",
      "description": "两位最佳闺蜜，莉莉和罗克珊，截然不同。莉莉是温柔与浪漫的化身，身着轻盈的粉色连衣裙，点缀着亮片和花卉图案。罗克珊则是朋克摇滚的真正女王，身穿黑色皮衣，佩戴哥特式耳环，拥有大胆的发型。但别忘了第三位闺蜜，梅洛迪，她巧妙地融合了这两种风格。玩家将能够尝试不同的装扮，选择最适合情人节的那一款！",
      "instructions": "遇见三位闺蜜，她们正准备庆祝翘首以盼的假期。每位女友都有自己的时尚偏好，但决定她们将如何庆祝假期的装扮全在你手中。游戏结束时，最成功的形象可以保存为PNG图片。根据游戏设备的不同，控制方式可以是电脑鼠标点击或触摸屏简单触摸。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "时尚",
        "女孩",
        "发型",
        "化妆",
        "情人节"
      ]
    },
    "zh-TW": {
      "title": "活力心靈 風華對抗搖滾",
      "description": "兩位最好的女夥伴，莉莉和羅克珊娜，是絕對的對立。莉莉是溫柔與羅曼蒂克的化身，身穿輕盈的粉紅色洋裝，上面飾有亮片和花紋。羅克珊娜是搖滾朋克的真正女王，身穿黑色皮衣，佩戴哥德式耳環和鮮明造型的髮型。但不要忘了第三位女夥伴，梅洛迪，她巧妙地融合了這兩種風格。玩家將能夠嘗試不同的造型，並選擇哪一種最適合情人節！",
      "instructions": "見識三位無話不談的好友，他們正準備慶祝期待已久的假期。每位女友都有她自己的特殊時尚偏好，但決定她們將穿著哪些服裝慶祝假期的，只取決於你。最成功的畫面可以在遊戲結束時保存為PNG圖片。根據遊戲設備的不同，使用電腦滑鼠點擊或觸控螢幕的簡單觸碰來控制遊戲。",
      "genres": [
        "打扮"
      ],
      "tags": [
        "時尚",
        "女孩",
        "髮型",
        "妝容",
        "情人節"
      ]
    },
    "zh-HK": {
      "title": "活力心靈 風華對抗搖滾",
      "description": "兩位最佳好姊妹，莉莉和羅克珊，是天差地遠的對照。莉莉是溫柔與羅曼蒂克的化身，身穿裝飾著亮片和花卉圖案的輕盈粉紅裙裝。羅克珊則是搖滾樂界的真正女王，黑色皮革裙裝、哥德式耳環和醒目的髮型。但不要忘了第三位好姊妹麥樂迪，她巧妙地結合了這兩種風格。玩家將能夠嘗試不同的造型並選擇最適合情人節的那一個！",
      "instructions": "遇見三個最佳朋友，她們正準備慶祝這個期待已久的假日。每位女友都有自己的獨特時尚偏好，但選擇她們將如何慶祝假日的造型，就完全取決於你。遊戲結束時，最成功的形象可保存為PNG圖片。根據遊戲設備，可使用電腦滑鼠點擊或觸控屏幕進行控制。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "時尚",
        "少女",
        "髮型",
        "妝容",
        "情人節"
      ]
    },
    "ja": {
      "title": "ビランティン・ハーツ・グラマー対パンク",
      "description": "二人の最高の親友、リリーとロクサナは正反対だ。リリーは優しさとロマンチックの体現であり、スッキリとしたピンクのドレスにパールと花柄が飾られている。ロクサナはパンクロックの真の女王で、黒いレザーのドレス、ゴシックなイヤリング、大胆なヘアスタイルを持っている。しかし、第三の親友であるメロディも忘れないで。彼女はこの二つのスタイルを巧みに融合している。プレイヤーはコーディネートを試してみることができ、バレンタインデーに最も合ったものを選ぶことができる！",
      "instructions": "三人の親友と会い、待ちに待った休暇を祝う準備をしています。それぞれのガールフレンドにはそれぞれの特別なファッションの好みがありますが、彼女たちがどのような服装で休暇を祝るかはあなた次第です。最も成功したイメージは、ゲームの最後にPNG画像として保存できます。ゲーム機器によっては、コンピューターのマウスクリックまたはタッチスクリーンの単純なタップで操作されます。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "ファッション",
        "ガールズ",
        "ヘアスタイル",
        "メイクアップ",
        "バレンタイン"
      ]
    },
    "ko": {
      "title": "빛나는 마음 글램어 대 비 퍼크",
      "description": "두 명의 최고의 친구, 라일리와 로사나는 정반대입니다. 라일리는 약혼과 로맨스의化身으로, 파스텔 퍼플 드레스에 쥬얼리와 꽃무늬가 장식된 공기 같은 드레스를 입고 있습니다. 로사나는 푸크rock의 진정한 여왕으로, 검은 가죽 드레스와 고딕 귀고리, 눈에 띄는 헤어스타일을 자랑합니다. 하지만 세 번째 친구 멜로디도 두 스타일을 마스터리하는 것을 잊지 마세요. 플레이어들은 옷장을 실험하고 밸런타인데이에 가장 적합한 것을 선택할 수 있을 것입니다!",
      "instructions": "세 명의 친구가 오랫동안 기다려온 휴가를 준비하고 있습니다. 각 여자친구는 자신만의 특별한 패션 취향을 가지고 있지만, 그들이 휴가를 맞이할 옷차림은 모두 당신의 선택에 달려 있습니다. 가장 성공적인 이미지는 게임이 끝나면 PNG 이미지로 저장할 수 있습니다. 게임 장치에 따라 컴퓨터 마우스 클릭이나 태치스크린의 간단한 터치로 제어됩니다.",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "패션",
        "여자",
        "머리카락 스타일링",
        "메이크업",
        "밸런타인"
      ]
    },
    "fr": {
      "title": "Coeurs vibrants Glamour vs Punk",
      "description": "Deux meilleures amies, Lily et Roxana, sont des opposées. Lily est la personnification de la tendre et du romantisme, vêtue de robes roses aériennes ornées de paillettes et de motifs floraux. Roxanne est la véritable reine du punk rock, avec ses robes en cuir noir, ses boucles d'oreilles gothiques et ses coiffures audacieuses. Mais ne oubliez pas la troisième amie, Melody, qui maîtrise à la perfection les deux styles. Les joueurs pourront expérimenter avec les tenues et choisir celle qui convient le mieux pour la Saint-Valentin !",
      "instructions": "Rencontrez trois meilleures amies, qui se préparent à célébrer la fête tant attendue. Chaque amie a ses propres préférences de mode spéciales, mais c'est à vous de décider dans quels tenus elles célébreront la fête. Les images les plus réussies peuvent être enregistrées à la fin du jeu sous forme d'images PNG. En fonction de l'appareil de jeu, un clic de souris sur ordinateur ou un simple toucher sur les écrans tactiles est utilisé pour le contrôle.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "mode",
        "filles",
        "coiffure",
        "maquillage",
        "Saint-Valentin"
      ]
    }
  }
};
